// Reference Library → record fill helpers.
//
// Source precedence is MANUAL FIRST everywhere: picking a library record
// fills only the fields the operator has left blank. Replacing a value that
// is already populated requires an explicit action (see `applyAllFromLibrary`,
// wired to a visible "Apply library values" control). Unlinking a record
// removes the link only — never the entered data.

const _filled = (v) => v !== "" && v != null;

export const LIB_FIELD_LABELS = {
  outerDiameter: "OD",
  innerDiameter: "ID",
  weightPpf:     "Weight",
  grade:         "Grade",
  connection:    "Connection",
  nominalSize:   "Nominal size",
  lengthFt:      "Length",
};

/** Fill only the blank fields of `target` from the mapped library values. */
export function fillBlanksFromLibrary(target, mapped) {
  const out = { ...target };
  for (const [k, v] of Object.entries(mapped || {})) {
    if (!_filled(out[k]) && _filled(v)) out[k] = v;
  }
  return out;
}

/** Explicit, user-initiated overwrite of every mapped field. */
export function applyAllFromLibrary(target, mapped) {
  const out = { ...target };
  for (const [k, v] of Object.entries(mapped || {})) {
    if (_filled(v)) out[k] = v;
  }
  return out;
}

/** Fields where the operator's own value differs from the library record. */
export function libraryConflicts(target, mapped) {
  return Object.entries(mapped || {})
    .filter(([k, v]) => _filled(v) && _filled(target?.[k]) && String(target[k]) !== String(v))
    .map(([k, v]) => ({ key: k, label: LIB_FIELD_LABELS[k] || k, current: target[k], library: v }));
}
